import { MembershipProfileTag as MembershipProfileTagModel } from '@models/membership/MembershipProfileTag'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileById } from '@store/membership/MembershipProfileReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { FC } from 'react'

type Props = SBModelComponent<MembershipProfileTagModel> & {}

const MembershipProfileTagOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectMembershipProfileById(id!))

  if (!item) {
    return <></>
  }

  return item.id
}

type MembershipProfileTagOptionType = {
  Option: typeof MembershipProfileTagOption
}

export { MembershipProfileTagOption, type MembershipProfileTagOptionType }
